import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { AngularFireDatabase, FirebaseListObservable } from "angularfire2/database-deprecated";
import { RouterModule, Router } from '@angular/router';
import { FirebaseApp } from 'angularfire2';

@Component({
  selector: 'app-typeedit',
  templateUrl: './typeedit.component.html',
  styleUrls: ['./typeedit.component.css']
})
export class TypeeditComponent implements OnInit {

  NameType;
  itemType;
  a;
  NameTitle;
  NameMetaDescription;
  NameMetaKeyword;
  constructor(private activatedRoute: ActivatedRoute, private af: AngularFireDatabase, private firebaseApp: FirebaseApp) {
    
    this.activatedRoute.params.subscribe(params => {
      this.a = params['id'];
    })

    let updateData = this.af.list('/Menu')
    updateData.subscribe((snp) => {
      for (var i = 0; i < snp.length; i++) {
        if (snp[i].Id == this.a) {
          this.itemType = snp[i]
          this.NameType = this.itemType.Name
          this.NameTitle = this.itemType.Title
          this.NameMetaDescription = this.itemType.MetaDescript
          this.NameMetaKeyword = this.itemType.MetaKeywords
        }
      }
    })

    
  }

  ngOnInit() {
  }
  clickEdit() {
    let itemTmp;
    let dataItem = {
      Id:this.a,
      Name:this.NameType,
      Title:this.NameTitle,
      MetaDescript:this.NameMetaDescription,
      MetaKeywords:this.NameMetaKeyword
    }
    let updateData = this.af.list('/Menu')
    updateData.subscribe((snap) => {
      for (var i = 0; i < snap.length; i++) {
        if (snap[i].Id == this.a) {
          itemTmp = snap[i]
          this.af.object('/Menu/'+snap[i].$key).update(dataItem).then((success)=>{
            alert("แก้ไขเสร็จสิ้น")
            window.location.reload();
          })
        }
      }
    })
  }

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/typepage/view/typeedit/typeedit.component.ts